import React, { useEffect, useState } from "react";
import { useScrollReveal } from "../hooks/useScrollReveal";

/**
 * Animated number counter — counts from 0 to `to` over `duration` ms when scrolled into view.
 * Suffix renders as-is (e.g., "+", "%").
 */
export default function CountUp({ to, duration = 1800, suffix = "", prefix = "", decimals = 0, className = "" }) {
  const [ref, visible] = useScrollReveal({ threshold: 0.4 });
  const [value, setValue] = useState(0);

  useEffect(() => {
    if (!visible) return;
    const start = performance.now();
    const target = Number(to) || 0;
    let raf;
    const tick = (now) => {
      const elapsed = now - start;
      const t = Math.min(1, elapsed / duration);
      // ease-out-quart
      const eased = 1 - Math.pow(1 - t, 4);
      setValue(target * eased);
      if (t < 1) raf = requestAnimationFrame(tick);
      else setValue(target);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [visible, to, duration]);

  const formatted = decimals > 0 ? value.toFixed(decimals) : Math.round(value).toString();

  return (
    <span ref={ref} className={className}>
      {prefix}
      {formatted}
      {suffix}
    </span>
  );
}
